import { render, staticRenderFns } from "./label_actions.vue.js?vue&type=template&id=fdd0ef06&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./label_actions.vue?vue&type=template&id=fdd0ef06&vue3"
import script from "./label_actions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./label_actions.vue?vue&type=script&lang=js&vue3"
export * from "./label_actions.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./label_actions.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports